module.exports = __webpack_public_path__ + "img/left-arrow.13374ec8.svg";